import React from "react";
import { FormHelperText, InputLabel, Stack, TextField } from "@mui/material";
import { sq } from "date-fns/locale";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import helper from "csvtojson";

const InputDate = (props) => {
  return (
    <Stack>
      <InputLabel sx={{ marginTop: "8px" }}>{props?.label}</InputLabel>
      <LocalizationProvider dateAdapter={AdapterDateFns} locale={sq}>
        <DatePicker
          value={props.value}
          //   views={["year", "month"]}
          onChange={props.onChange}
          error={props.error ? props.error : false}
          inputFormat="dd/MM/yyyy"
          renderInput={(params) => (
            <TextField
              {...params}
              variant="outlined"
              InputLabelProps={{ shrink: true }}
              label=""
              sx={{
                "& .MuiInputAdornment-root.MuiInputAdornment-root": {
                  minWidth: "40px",
                },
                "& .MuiInputLabel-root": { display: "none" },
              }}
              error={props.error ? props.error : false}
              inputProps={{
                ...params.inputProps,
                placeholder: "dd/mm/yyyy",
              }}
            />
          )}
          {...props}
        />
        <FormHelperText error={props.error}>{props?.helperText}</FormHelperText>
      </LocalizationProvider>
    </Stack>
  );
};

export default InputDate;
